var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icona_genera",
    "data-name": "icona genera",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_270",
    "data-name": "Tracciato 270",
    d: "M0,129.819l1.83,1.83,8.839-8.839-1.83-1.83Zm1.83.662-.662-.662L6.5,124.484l.662.662Zm5.919-5.919-.662-.662,1.752-1.752.662.662Z",
    transform: "translate(0 -117.649)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_271",
    "data-name": "Tracciato 271",
    d: "M48.8,5.687,49.8,3.849,51.64,2.844,49.8,1.839,48.8,0,47.792,1.839,45.954,2.844l1.838,1.005Zm-.4-3.24.4-.725.4.725.725.4-.725.4-.4.725-.4-.725-.725-.4Z",
    transform: "translate(-44.689 -0.001)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_272",
    "data-name": "Tracciato 272",
    d: "M336.355,4.805l.849-1.553,1.553-.849L337.2,1.553,336.355,0l-.849,1.553-1.553.849,1.553.849Zm-.241-2.643.241-.44.241.44.44.241-.44.241-.241.44-.241-.44-.44-.241Z",
    transform: "translate(-324.757)",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_273",
    "data-name": "Tracciato 273",
    d: "M337.2,233.553,336.355,232l-.849,1.553-1.553.849,1.553.849.849,1.553.849-1.553,1.553-.849Zm-.609,1.09-.241.44-.241-.44-.44-.241.44-.241.241-.44.241.44.44.241Z",
    transform: "translate(-324.757 -225.612)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerate);
export default __webpack_public_path__ + "static/media/generate.10125d15ba1ebe56bebed961bd05aa7a.svg";
export { ForwardRef as ReactComponent };